import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';
import { Button } from '../components/ui/button';
import { Briefcase, Mail } from 'lucide-react';

const CareersPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h1 className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#214140' }}>
                  Careers
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  We're a growing team passionate about improving patient safety and supporting healthcare professionals.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* No Current Openings */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-2xl mx-auto">
                <div className="w-20 h-20 rounded-full flex items-center justify-center mb-8 mx-auto" style={{ backgroundColor: '#DFEAF0' }}>
                  <Briefcase className="h-10 w-10" style={{ color: '#214140' }} />
                </div>
                <h2 className="text-2xl lg:text-3xl font-bold mb-4" style={{ color: '#214140' }}>
                  No Current Openings
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  There are no open positions at this time. However, we're always interested in connecting
                  with talented individuals who share our mission of improving critical care.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-20" style={{ backgroundColor: '#273139' }}>
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-2xl mx-auto">
                <h2 className="text-2xl lg:text-3xl font-bold mb-4 text-white">
                  Interested in Working With Us?
                </h2>
                <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                  Contact us to learn more about future opportunities to join the Cordflex® team.
                </p>
                <Button
                  className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-opacity duration-200"
                  style={{ backgroundColor: '#8BBAB8', color: 'white' }}
                  onClick={() => window.location.href = '/contact'}
                >
                  <Mail className="h-5 w-5 mr-2" />
                  Contact Us
                </Button>
              </div>
            </AnimatedSection>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CareersPage;
